import LegacyPatientInfo from './LegacyPatientInfo';
export default LegacyPatientInfo;
